import customAxios from "./axiosConfig";

const WoocommerceService = {
    isValidUrl: function(url) {
        // eslint-disable-next-line
        let expression = /^((http:\/\/www\.|https:\/\/www\.)[a-z0-9]+|(http:\/\/|https:\/\/)[0-9]+)([\-\.]{1}[a-z0-9]+)*\.[a-z0-9]{2,6}(:[0-9]{1,5})?(\/)?$/;
        return expression.test(url);
    },
    status: function(params) {
        let api_url = window.Urls["woocommerceuser_status"]();
        return customAxios.get(api_url, {params: params});
    },
    connect: function(data) {
        let api_url = window.Urls["woocommerceuser_signup"]();
        return customAxios.post(api_url, data);
    },
    manuallyConnect: function(data) {
        let api_url = window.Urls["woocommerceuser_manual_signup"]();
        return customAxios.post(api_url, data);
    },
    updateSettings: function(data) {
        let api_url = window.Urls["woocommerceuser_update_settings"]();
        return customAxios.post(api_url, data);
    },
    disconnect(params) {
        let api_url = window.Urls["woocommerceuser_disconnect"]();
        return customAxios.get(api_url, {params: params});
    },
    reconnectWebhooks(params) {
        let api_url = window.Urls["woocommerceuser-reconnect-webhooks"]();
        return customAxios.get(api_url, {params: params});
    }
}

export default WoocommerceService;